import * as i0 from '@angular/core';
import { inject, EventEmitter, signal, TemplateRef, ElementRef, Component, ChangeDetectionStrategy, ViewChild, ViewChildren, ContentChild, Input, Output, NgModule } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EMPTY_QUERY, TUI_TRUE_HANDLER, TUI_FALSE_HANDLER } from '@taiga-ui/cdk/constants';
import { tuiInjectElement, tuiRetargetedBoundaryCrossing, tuiGetActualTarget, tuiIsElement, tuiGetClipboardDataText } from '@taiga-ui/cdk/utils/dom';
import { tuiIsNativeFocusedIn } from '@taiga-ui/cdk/utils/focus';
import { tuiCreateToken, tuiProvideOptions, tuiIsString, tuiArrayRemove } from '@taiga-ui/cdk/utils/miscellaneous';
import { tuiAsDataListHost, TuiDataListDirective } from '@taiga-ui/core/components/data-list';
import * as i5 from '@taiga-ui/core/components/scrollbar';
import { TuiScrollbar } from '@taiga-ui/core/components/scrollbar';
import { TUI_TEXTFIELD_OPTIONS } from '@taiga-ui/core/components/textfield';
import * as i1 from '@taiga-ui/core/directives/dropdown';
import { TuiDropdownOpen, TuiDropdownFixed, TuiDropdown } from '@taiga-ui/core/directives/dropdown';
import { TuiHintOptionsDirective } from '@taiga-ui/core/directives/hint';
import { TUI_COMMON_ICONS } from '@taiga-ui/core/tokens';
import { AbstractTuiMultipleControl, tuiAsControl } from '@taiga-ui/legacy/classes';
import * as i8 from '@taiga-ui/legacy/directives';
import { TUI_TEXTFIELD_WATCHED_CONTROLLER, TEXTFIELD_CONTROLLER_PROVIDER, TuiWrapperModule, TuiLegacyDropdownOpenMonitorDirective } from '@taiga-ui/legacy/directives';
import { tuiAsFocusableItemAccessor } from '@taiga-ui/legacy/tokens';
import * as i4 from '@taiga-ui/polymorpheus';
import { PolymorpheusOutlet, PolymorpheusTemplate } from '@taiga-ui/polymorpheus';
import { timer } from 'rxjs';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i6 from '@taiga-ui/legacy/components/tooltip';
import { TuiTooltipModule } from '@taiga-ui/legacy/components/tooltip';
import * as i7 from '@taiga-ui/legacy/components/tag';
import { TuiTagModule } from '@taiga-ui/legacy/components/tag';
import * as i9 from '@taiga-ui/core/directives/appearance';
import { TuiAppearance } from '@taiga-ui/core/directives/appearance';
import * as i10 from '@taiga-ui/core/components/icon';
import { TuiIcon } from '@taiga-ui/core/components/icon';
import { TuiHovered } from '@taiga-ui/cdk/directives/hovered';
import { TuiScrollService } from '@taiga-ui/cdk/services';
const _c0 = ["focusableElement"];
const _c1 = ["tagsContainer"];
const _c2 = ["cleaner"];
const _c3 = ["errorIcon"];
const _c4 = ["tag"];
const _c5 = [[["tuiContent"]], [["select"]], "*"];
const _c6 = ["tuiContent", "select", "*"];
const _c7 = () => ({
  standalone: true
});
const _c8 = a0 => ({
  $implicit: a0
});
function TuiInputTagComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TuiInputTagComponent_div_5_tui_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-icon", 23);
  }
  if (rf & 2) {
    const src_r2 = ctx.polymorpheusOutlet;
    i0.ɵɵproperty("icon", src_r2.toString());
  }
}
function TuiInputTagComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtemplate(1, TuiInputTagComponent_div_5_tui_icon_1_Template, 1, 1, "tui-icon", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("polymorpheusOutlet", ctx_r2.iconStart)("polymorpheusOutletContext", i0.ɵɵpureFunction1(2, _c8, ctx_r2.size));
  }
}
function TuiInputTagComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("t-placeholder_raised", ctx_r2.placeholderRaised);
  }
}
function TuiInputTagComponent_ng_container_11_tui_tag_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tui-tag", 26, 3);
    i0.ɵɵlistener("edited", function TuiInputTagComponent_ng_container_11_tui_tag_1_Template_tui_tag_edited_0_listener($event) {
      const index_r5 = i0.ɵɵrestoreView(_r4).index;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onTagEdited($event, index_r5));
    })("keydown.arrowLeft.prevent", function TuiInputTagComponent_ng_container_11_tui_tag_1_Template_tui_tag_keydown_arrowLeft_prevent_0_listener() {
      const index_r5 = i0.ɵɵrestoreView(_r4).index;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onTagKeyDownArrowLeft(index_r5));
    })("keydown.arrowRight.prevent", function TuiInputTagComponent_ng_container_11_tui_tag_1_Template_tui_tag_keydown_arrowRight_prevent_0_listener() {
      const index_r5 = i0.ɵɵrestoreView(_r4).index;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onTagKeyDownArrowRight(index_r5));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("autoColor", ctx_r2.autoColor)("disabled", ctx_r2.computedDisabled || ctx_r2.disabledItemHandler(item_r6))("editable", ctx_r2.editable && !ctx_r2.readOnly)("hoverable", !ctx_r2.readOnly)("leftContent", ctx_r2.getLeftContent(item_r6))("maxLength", ctx_r2.maxLength)("removable", !ctx_r2.readOnly && ctx_r2.removable)("separator", ctx_r2.separator)("size", ctx_r2.controller.size)("status", ctx_r2.status)("value", item_r6.toString());
  }
}
function TuiInputTagComponent_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TuiInputTagComponent_ng_container_11_tui_tag_1_Template, 2, 11, "tui-tag", 25);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.value)("ngForTrackBy", ctx_r2.trackByFn);
  }
}
function TuiInputTagComponent_ng_template_12_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 28);
  }
  if (rf & 2) {
    const item_r7 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("t-text_comma", ctx_r2.computedFocused && !ctx_r2.inputHidden)("t-text_disabled", ctx_r2.disabledItemHandler(item_r7))("t-text_error", !ctx_r2.tagValidator(item_r7));
    i0.ɵɵproperty("textContent", item_r7);
  }
}
function TuiInputTagComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TuiInputTagComponent_ng_template_12_span_0_Template, 1, 7, "span", 27);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", ctx_r2.value);
  }
}
function TuiInputTagComponent_div_22_ng_container_1_tui_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tui-icon", 33, 4);
    i0.ɵɵlistener("click.stop", function TuiInputTagComponent_div_22_ng_container_1_tui_icon_1_Template_tui_icon_click_stop_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.onCleanerClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const src_r9 = ctx.polymorpheusOutlet;
    i0.ɵɵproperty("icon", src_r9.toString());
  }
}
function TuiInputTagComponent_div_22_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TuiInputTagComponent_div_22_ng_container_1_tui_icon_1_Template, 2, 1, "tui-icon", 32);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("polymorpheusOutlet", ctx_r2.iconCleaner)("polymorpheusOutletContext", i0.ɵɵpureFunction1(2, _c8, ctx_r2.size));
  }
}
function TuiInputTagComponent_div_22_tui_tooltip_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-tooltip", 34);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("content", ctx_r2.hintOptions == null ? null : ctx_r2.hintOptions.content)("describeId", ctx_r2.id);
  }
}
function TuiInputTagComponent_div_22_div_3_tui_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-icon", 23);
  }
  if (rf & 2) {
    const src_r10 = ctx.polymorpheusOutlet;
    i0.ɵɵproperty("icon", src_r10.toString());
  }
}
function TuiInputTagComponent_div_22_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TuiInputTagComponent_div_22_div_3_tui_icon_1_Template, 1, 1, "tui-icon", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("polymorpheusOutlet", ctx_r2.icon)("polymorpheusOutletContext", i0.ɵɵpureFunction1(2, _c8, ctx_r2.size));
  }
}
function TuiInputTagComponent_div_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtemplate(1, TuiInputTagComponent_div_22_ng_container_1_Template, 2, 4, "ng-container", 5)(2, TuiInputTagComponent_div_22_tui_tooltip_2_Template, 1, 2, "tui-tooltip", 30)(3, TuiInputTagComponent_div_22_div_3_Template, 2, 4, "div", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.hasCleaner);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showHint);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.icon);
  }
}
function TuiInputTagComponent_ng_template_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-icon", 36);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r2.icons.error);
  }
}
const TUI_INPUT_TAG_DEFAULT_OPTIONS = {
  autoColor: false,
  separator: ',',
  tagStatus: 'default',
  uniqueTags: true
};
/**
 * @deprecated: drop in v5.0
 * Default parameters for InputTag component
 */
const TUI_INPUT_TAG_OPTIONS = tuiCreateToken(TUI_INPUT_TAG_DEFAULT_OPTIONS);
function tuiInputTagOptionsProvider(options) {
  return tuiProvideOptions(TUI_INPUT_TAG_OPTIONS, options, TUI_INPUT_TAG_DEFAULT_OPTIONS);
}
const TAG_SIZE_REM = {
  s: 1.25,
  m: 1.5,
  l: 2
};
const LINE_HEIGHT_REM = {
  s: 1,
  m: 1.25,
  l: 1.25
};
const TAG_VERTICAL_SPACE_REM = 0.125;
let TuiInputTagComponent = /*#__PURE__*/(() => {
  class TuiInputTagComponent extends AbstractTuiMultipleControl {
    constructor() {
      super(...arguments);
      this.tags = EMPTY_QUERY;
      this.el = tuiInjectElement();
      this.options = inject(TUI_INPUT_TAG_OPTIONS);
      this.textfieldOptions = inject(TUI_TEXTFIELD_OPTIONS);
      this.hintOptions = inject(TuiHintOptionsDirective, {
        optional: true
      });
      this.controller = inject(TUI_TEXTFIELD_WATCHED_CONTROLLER);
      this.icons = inject(TUI_COMMON_ICONS);
      this.status = this.options.tagStatus;
      this.open = false;
      this.separator = this.options.separator;
      this.search = '';
      this.editable = true;
      this.tagValidator = TUI_TRUE_HANDLER;
      this.rows = Infinity;
      this.inputHidden = false;
      this.uniqueTags = this.options.uniqueTags;
      this.autoColor = this.options.autoColor;
      this.maxLength = null;
      this.placeholder = '';
      this.removable = true;
      this.disabledItemHandler = TUI_FALSE_HANDLER;
      this.searchChange = new EventEmitter();
      this.pseudoOpen = signal(false);
    }
    set pseudoFocusedSetter(value) {
      if (!value && !this.focused) {
        this.scrollTo(0);
      }
      this.pseudoFocus = value;
    }
    /**
     * @deprecated hack
     */
    set setPseudoOpen(value) {
      this.pseudoOpen.set(value);
    }
    get labelOutside() {
      const {
        size,
        labelOutside
      } = this.controller;
      return this.appearance === 'table' || size === 's' || labelOutside;
    }
    get size() {
      return this.controller.size;
    }
    get nativeFocusableElement() {
      return !this.focusableElement || this.computedDisabled ? null : this.focusableElement.nativeElement;
    }
    get hasValue() {
      return !!this.value.length || this.hasNativeValue;
    }
    get hasExampleText() {
      return !!this.nativeFocusableElement?.placeholder && this.computedFocused && !this.hasValue && !this.readOnly;
    }
    get hasPlaceholder() {
      return !this.labelOutside || !this.hasValue && (!this.hasExampleText || this.inputHidden);
    }
    get focused() {
      return tuiIsNativeFocusedIn(this.el) || !!this.dropdown?.tuiDropdownOpen;
    }
    get tagsEmpty() {
      return (!this.focused || this.inputHidden) && !this.value.length && !this.search?.trim()?.length && !this.placeholder || !!this.valueContent;
    }
    onTagEdited(value, index) {
      this.focusInput(value === '');
      this.value = this.filterValue(this.value.map((tag, tagIndex) => tagIndex !== index ? tag : value.split(this.separator).map(tag => tag.trim()).filter(Boolean)).reduce((result, item) => result.concat(item), []));
    }
    handleOption(item) {
      this.focusInput();
      this.updateSearch('');
      this.value = this.filterValue(this.value.concat(item));
      this.open = false;
      this.scrollTo();
    }
    setDisabledState() {
      super.setDisabledState();
      this.open = false;
    }
    get iconStart() {
      return this.controller.iconStart;
    }
    get appearance() {
      return this.textfieldOptions.appearance() === 'table' ? 'table' : this.controller.appearance;
    }
    get expandable() {
      return this.rows > 1;
    }
    get icon() {
      return this.controller.icon;
    }
    get iconCleaner() {
      return this.controller.options.iconCleaner;
    }
    get hasCleaner() {
      return this.controller.cleaner && this.hasValue && this.interactive;
    }
    get hasNativeValue() {
      return !!this.search;
    }
    get placeholderRaised() {
      return !this.labelOutside && (this.computedFocused && !this.readOnly || this.hasValue);
    }
    get hasRightIcons() {
      return this.hasCleaner || !!this.icon || !!this.hintOptions?.content && !this.computedDisabled;
    }
    get showHint() {
      return !!this.hintOptions?.content && (this.controller.options.hintOnDisabled || !this.computedDisabled);
    }
    get canOpen() {
      return this.interactive && !!this.datalist;
    }
    get computeMaxHeight() {
      return this.expandable ? this.rows * this.lineHeight : null;
    }
    onFocusInOut() {
      this.cdr.detectChanges();
    }
    detectRetargetFromLabel(event) {
      if (tuiRetargetedBoundaryCrossing(event)) {
        event.stopImmediatePropagation();
      }
    }
    getLeftContent(tag) {
      return !this.tagValidator(tag) && this.errorIconTemplate ? this.errorIconTemplate : '';
    }
    onCleanerClick() {
      this.updateSearch('');
      this.clear();
      this.focusInput();
    }
    onActiveZone(active) {
      this.open = false;
      this.addTag();
      this.updateFocused(active);
      if (!active && !this.computedFocused) {
        this.scrollTo(0);
      }
    }
    onMouseDown(event) {
      const actualTarget = tuiGetActualTarget(event);
      if (!this.focusableElement || actualTarget === this.focusableElement.nativeElement || !tuiIsElement(event.target) || this.cleanerSvg?.nativeElement.contains(event.target) || this.tagsContainer && actualTarget !== this.tagsContainer.nativeElement && this.tagsContainer.nativeElement.contains(actualTarget)) {
        return;
      }
      event.preventDefault();
      this.focusInput();
    }
    onFieldKeyDownBackspace(event) {
      if (!this.labelOutside && !this.hasNativeValue && this.value.length) {
        this.deleteLastEnabledItem();
      } else {
        this.onFieldKeyDownArrowLeft(event);
      }
    }
    onFieldKeyDownArrowLeft(event) {
      if (!this.labelOutside || this.hasNativeValue || !this.value.length) {
        return;
      }
      event.preventDefault();
      this.tags.last.nativeElement.focus();
    }
    onFieldKeyDownEnter() {
      this.addTag();
      this.scrollTo();
    }
    onTagKeyDownArrowLeft(currentIndex) {
      if (currentIndex > 0) {
        this.onScrollKeyDown(currentIndex, -1);
      }
    }
    onTagKeyDownArrowRight(currentIndex) {
      if (currentIndex === this.value.length - 1) {
        this.focusInput();
      } else {
        this.onScrollKeyDown(currentIndex, 1);
      }
    }
    onInput(value) {
      const array = value.split(this.separator);
      const tags = array.map(item => this.clippedValue(item.trim())).filter(item => item.length > 0);
      const validated = tags.filter(tag => !this.disabledItemHandler(tag));
      const invalid = tags.filter(tag => this.disabledItemHandler(tag));
      if (array.length > 1) {
        const search = invalid.length ? invalid.join(tuiIsString(this.separator) ? this.separator : ',') : '';
        this.updateSearch(this.clippedValue(search));
        this.value = this.filterValue([...this.value, ...validated]);
      } else {
        this.updateSearch(this.clippedValue(value));
      }
      this.open = this.hasNativeValue;
    }
    onPaste(event) {
      const pasted = tuiGetClipboardDataText(event);
      this.onInput(pasted || '');
    }
    onDrop({
      dataTransfer
    }) {
      if (dataTransfer) {
        this.onInput(dataTransfer.getData('text') || '');
      }
    }
    trackByFn(_, tag) {
      // Actually tag has TuiStringifiableItem type not string
      return tag.toString();
    }
    get lineHeight() {
      return this.labelOutside ? TAG_SIZE_REM[this.controller.size] + 2 * TAG_VERTICAL_SPACE_REM : LINE_HEIGHT_REM[this.controller.size];
    }
    scrollTo(scrollLeft = this.scrollBar?.nativeElement.scrollWidth) {
      // Allow change detection to run and add new tag to DOM
      timer(0).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        if (this.scrollBar) {
          this.scrollBar.nativeElement.scrollLeft = scrollLeft || 0;
        }
      });
    }
    filterValue(value) {
      const seen = new Set();
      return value.reverse().filter(item => !this.uniqueTags || item && !seen.has(item) && seen.add(item)).reverse();
    }
    onScrollKeyDown(currentIndex, flag) {
      const tag = this.tags.find((_item, index) => index === currentIndex + flag);
      if (!tag || !this.scrollBar) {
        return;
      }
      tag.nativeElement.focus();
      if (flag * this.scrollBar.nativeElement.clientWidth - flag * tag.nativeElement.offsetLeft - tag.nativeElement.clientWidth < 0) {
        this.scrollBar.nativeElement.scrollLeft += flag * tag.nativeElement.clientWidth;
      }
    }
    updateSearch(value) {
      if (this.focusableElement) {
        this.focusableElement.nativeElement.value = value;
      }
      this.search = value;
      this.searchChange.emit(value);
    }
    addTag() {
      const inputValue = this.search?.trim() ?? '';
      if (!inputValue || this.disabledItemHandler(inputValue)) {
        return;
      }
      this.updateSearch('');
      this.value = this.filterValue(this.value.concat(inputValue));
    }
    deleteLastEnabledItem() {
      for (let index = this.value.length - 1; index >= 0; index--) {
        if (!this.disabledItemHandler(this.value[index] ?? '')) {
          this.value = tuiArrayRemove(this.value, index);
          break;
        }
      }
    }
    focusInput(preventScroll = false) {
      this.nativeFocusableElement?.focus({
        preventScroll
      });
    }
    clippedValue(value) {
      return value.slice(0, this.maxLength || value.length);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵTuiInputTagComponent_BaseFactory;
        return function TuiInputTagComponent_Factory(__ngFactoryType__) {
          return (ɵTuiInputTagComponent_BaseFactory || (ɵTuiInputTagComponent_BaseFactory = i0.ɵɵgetInheritedFactory(TuiInputTagComponent)))(__ngFactoryType__ || TuiInputTagComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiInputTagComponent,
        selectors: [["tui-input-tag"]],
        contentQueries: function TuiInputTagComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, TuiDataListDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, PolymorpheusOutlet, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.datalist = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.valueContent = _t.first);
          }
        },
        viewQuery: function TuiInputTagComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(TuiDropdownOpen, 5);
            i0.ɵɵviewQuery(_c0, 5);
            i0.ɵɵviewQuery(_c1, 5);
            i0.ɵɵviewQuery(_c2, 5, ElementRef);
            i0.ɵɵviewQuery(TuiScrollbar, 5, ElementRef);
            i0.ɵɵviewQuery(_c3, 5);
            i0.ɵɵviewQuery(_c4, 5, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.focusableElement = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tagsContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cleanerSvg = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollBar = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.errorIconTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tags = _t);
          }
        },
        hostVars: 7,
        hostBindings: function TuiInputTagComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("focusin.capture.zoneless", function TuiInputTagComponent_focusin_capture_zoneless_HostBindingHandler() {
              return ctx.onFocusInOut();
            })("focusout.capture.zoneless", function TuiInputTagComponent_focusout_capture_zoneless_HostBindingHandler() {
              return ctx.onFocusInOut();
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("data-size", ctx.size);
            i0.ɵɵclassProp("_icon-start", ctx.iconStart)("_expandable", ctx.expandable)("_label-outside", ctx.labelOutside);
          }
        },
        inputs: {
          separator: "separator",
          search: "search",
          editable: "editable",
          tagValidator: "tagValidator",
          rows: "rows",
          inputHidden: "inputHidden",
          uniqueTags: "uniqueTags",
          autoColor: "autoColor",
          maxLength: "maxLength",
          placeholder: "placeholder",
          removable: "removable",
          disabledItemHandler: "disabledItemHandler",
          pseudoFocusedSetter: [0, "pseudoFocused", "pseudoFocusedSetter"],
          setPseudoOpen: [0, "pseudoOpen", "setPseudoOpen"]
        },
        outputs: {
          searchChange: "searchChange"
        },
        standalone: false,
        features: [i0.ɵɵProvidersFeature([tuiAsFocusableItemAccessor(TuiInputTagComponent), tuiAsControl(TuiInputTagComponent), tuiAsDataListHost(TuiInputTagComponent), TEXTFIELD_CONTROLLER_PROVIDER]), i0.ɵɵHostDirectivesFeature([i1.TuiDropdownFixed]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c6,
        decls: 25,
        vars: 36,
        consts: [["text", ""], ["focusableElement", ""], ["errorIcon", ""], ["tag", ""], ["cleaner", ""], [4, "ngIf"], ["tuiDropdownOpenMonitor", "", 1, "t-hosted", 3, "tuiDropdownOpenChange", "tuiActiveZoneChange", "tuiDropdown", "tuiDropdownEnabled", "tuiDropdownOpen"], ["tuiWrapper", "", 3, "click.prevent.zoneless", "mousedown", "appearance", "disabled", "focus", "hover", "invalid", "readOnly"], [1, "t-content"], ["class", "t-icon t-icon_left t-textfield-icon t-icon-wrapper", 4, "ngIf"], [1, "t-wrapper"], [1, "t-absolute-wrapper"], ["automation-id", "tui-input-tag__placeholder", "class", "t-placeholder", 3, "t-placeholder_raised", 4, "ngIf"], [1, "t-scrollbar", 3, "hidden"], [1, "t-tags"], [4, "ngIf", "ngIfElse"], [1, "t-input-wrapper"], [1, "t-ghost"], ["automation-id", "tui-input-tag__native", "type", "text", 1, "t-native", 3, "drop.prevent", "keydown.arrowLeft", "keydown.backspace", "keydown.enter.prevent", "ngModelChange", "paste.prevent", "disabled", "id", "ngModel", "ngModelOptions", "placeholder", "readOnly", "tabIndex"], [1, "t-value-content"], ["class", "t-icons t-icon-wrapper", 4, "ngIf"], [1, "t-icon", "t-icon_left", "t-textfield-icon", "t-icon-wrapper"], ["tuiAppearance", "icon", 3, "icon", 4, "polymorpheusOutlet", "polymorpheusOutletContext"], ["tuiAppearance", "icon", 3, "icon"], ["automation-id", "tui-input-tag__placeholder", 1, "t-placeholder"], ["automation-id", "tui-input-tag__tag", "tabIndex", "-1", "class", "t-tag", 3, "autoColor", "disabled", "editable", "hoverable", "leftContent", "maxLength", "removable", "separator", "size", "status", "value", "edited", "keydown.arrowLeft.prevent", "keydown.arrowRight.prevent", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["automation-id", "tui-input-tag__tag", "tabIndex", "-1", 1, "t-tag", 3, "edited", "keydown.arrowLeft.prevent", "keydown.arrowRight.prevent", "autoColor", "disabled", "editable", "hoverable", "leftContent", "maxLength", "removable", "separator", "size", "status", "value"], ["class", "t-text", 3, "t-text_comma", "t-text_disabled", "t-text_error", "textContent", 4, "ngFor", "ngForOf"], [1, "t-text", 3, "textContent"], [1, "t-icons", "t-icon-wrapper"], ["automation-id", "tui-input-tag__tooltip", "class", "t-tooltip", 3, "content", "describeId", 4, "ngIf"], ["class", "t-icon t-textfield-icon", 4, "ngIf"], ["automation-id", "tui-input-tag__cleaner", "tuiAppearance", "icon", "class", "t-cleaner", 3, "icon", "click.stop", 4, "polymorpheusOutlet", "polymorpheusOutletContext"], ["automation-id", "tui-input-tag__cleaner", "tuiAppearance", "icon", 1, "t-cleaner", 3, "click.stop", "icon"], ["automation-id", "tui-input-tag__tooltip", 1, "t-tooltip", 3, "content", "describeId"], [1, "t-icon", "t-textfield-icon"], [1, "t-error-icon", 3, "icon"]],
        template: function TuiInputTagComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c5);
            i0.ɵɵtemplate(0, TuiInputTagComponent_ng_container_0_Template, 1, 0, "ng-container", 5);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵelementStart(2, "div", 6);
            i0.ɵɵtwoWayListener("tuiDropdownOpenChange", function TuiInputTagComponent_Template_div_tuiDropdownOpenChange_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.open, $event) || (ctx.open = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("tuiActiveZoneChange", function TuiInputTagComponent_Template_div_tuiActiveZoneChange_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onActiveZone($event));
            });
            i0.ɵɵelementStart(3, "div", 7);
            i0.ɵɵlistener("click.prevent.zoneless", function TuiInputTagComponent_Template_div_click_prevent_zoneless_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.detectRetargetFromLabel($event));
            })("mousedown", function TuiInputTagComponent_Template_div_mousedown_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onMouseDown($event));
            });
            i0.ɵɵelementStart(4, "div", 8);
            i0.ɵɵtemplate(5, TuiInputTagComponent_div_5_Template, 2, 4, "div", 9);
            i0.ɵɵelementStart(6, "div", 10)(7, "div", 11);
            i0.ɵɵtemplate(8, TuiInputTagComponent_div_8_Template, 2, 2, "div", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "tui-scrollbar", 13)(10, "div", 14);
            i0.ɵɵtemplate(11, TuiInputTagComponent_ng_container_11_Template, 2, 2, "ng-container", 15)(12, TuiInputTagComponent_ng_template_12_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(14, "div", 16)(15, "div", 17);
            i0.ɵɵtext(16);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "input", 18, 1);
            i0.ɵɵlistener("drop.prevent", function TuiInputTagComponent_Template_input_drop_prevent_17_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onDrop($event));
            })("keydown.arrowLeft", function TuiInputTagComponent_Template_input_keydown_arrowLeft_17_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFieldKeyDownArrowLeft($event));
            })("keydown.backspace", function TuiInputTagComponent_Template_input_keydown_backspace_17_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFieldKeyDownBackspace($event));
            })("keydown.enter.prevent", function TuiInputTagComponent_Template_input_keydown_enter_prevent_17_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFieldKeyDownEnter());
            })("ngModelChange", function TuiInputTagComponent_Template_input_ngModelChange_17_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onInput($event));
            })("paste.prevent", function TuiInputTagComponent_Template_input_paste_prevent_17_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onPaste($event));
            });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(19, "div", 19);
            i0.ɵɵprojection(20);
            i0.ɵɵelementEnd()()();
            i0.ɵɵprojection(21, 1);
            i0.ɵɵtemplate(22, TuiInputTagComponent_div_22_Template, 4, 3, "div", 20);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(23, TuiInputTagComponent_ng_template_23_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const text_r11 = i0.ɵɵreference(13);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 33, ctx.hintOptions == null ? null : ctx.hintOptions.change$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("tuiDropdown", ctx.datalist || "")("tuiDropdownEnabled", ctx.canOpen);
            i0.ɵɵtwoWayProperty("tuiDropdownOpen", ctx.open);
            i0.ɵɵadvance();
            i0.ɵɵproperty("appearance", ctx.appearance)("disabled", ctx.computedDisabled)("focus", ctx.computedFocused)("hover", ctx.pseudoHover)("invalid", ctx.computedInvalid)("readOnly", ctx.readOnly);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.iconStart);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.hasPlaceholder);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("max-height", ctx.computeMaxHeight, "rem");
            i0.ɵɵproperty("hidden", !ctx.expandable);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("t-tags_empty", ctx.tagsEmpty);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.labelOutside)("ngIfElse", text_r11);
            i0.ɵɵadvance(3);
            i0.ɵɵclassProp("t-input-wrapper_collapsed", ctx.computedDisabled || ctx.readOnly || ctx.inputHidden);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.search);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("t-native_hidden", ctx.inputHidden);
            i0.ɵɵproperty("disabled", ctx.computedDisabled)("id", ctx.id)("ngModel", ctx.search)("ngModelOptions", i0.ɵɵpureFunction0(35, _c7))("placeholder", ctx.placeholder)("readOnly", ctx.readOnly || ctx.inputHidden)("tabIndex", ctx.computedFocusable ? 0 : -1);
            i0.ɵɵattribute("maxLength", ctx.maxLength);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.hasRightIcons);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgModel, i4.PolymorpheusOutlet, i5.TuiScrollbar, i6.TuiTooltipComponent, i7.TuiTagComponent, i8.TuiWrapperDirective, i8.TuiLegacyDropdownOpenMonitorDirective, i9.TuiAppearance, i10.TuiIcon, i1.TuiDropdownDirective, i1.TuiDropdownOpen, i2.AsyncPipe],
        styles: ["[_nghost-%COMP%]{position:relative;display:block;text-align:start;border-radius:var(--tui-radius-m);block-size:var(--tui-height);min-block-size:var(--tui-height);max-block-size:var(--tui-height)}[data-size=s][_nghost-%COMP%]{--tui-height: var(--tui-height-s);font:var(--tui-font-text-s)}[data-size=m][_nghost-%COMP%]{--tui-height: var(--tui-height-m);font:var(--tui-font-text-s)}[data-size=l][_nghost-%COMP%]{--tui-height: var(--tui-height-l);font:var(--tui-font-text-m);line-height:1.25rem}[_nghost-%COMP%]   *:disabled[_nghost-%COMP%], *:disabled   [_nghost-%COMP%]{pointer-events:none}.t-input[_ngcontent-%COMP%]{padding:0;margin:0;border-width:0;border-radius:inherit;background:none;font-size:inherit;line-height:inherit;font-weight:inherit;color:inherit;caret-color:currentColor;outline:none;-webkit-appearance:none;appearance:none;word-break:keep-all;-webkit-text-fill-color:currentColor;position:absolute;top:0;left:0;inline-size:100%;block-size:100%;border-style:solid;border-color:transparent;border-inline-start-width:var(--t-border-start, 0);border-inline-end-width:var(--t-border-end, 0);text-indent:var(--t-text-indent);color:var(--tui-text-primary);text-align:inherit;box-sizing:border-box;white-space:nowrap;overflow:hidden;text-transform:inherit;resize:none}.t-input[_ngcontent-%COMP%]:-webkit-autofill, .t-input[_ngcontent-%COMP%]:-webkit-autofill:hover, .t-input[_ngcontent-%COMP%]:-webkit-autofill:focus{-webkit-text-fill-color:var(--tui-text-primary)!important;border-color:var(--tui-service-autofill-background);box-shadow:0 0 0 100rem var(--tui-service-autofill-background) inset!important}.t-input[inputMode=none][_ngcontent-%COMP%]{caret-color:transparent}.t-input[_ngcontent-%COMP%]:-webkit-autofill, .t-input[_ngcontent-%COMP%]:-webkit-autofill:first-line{font-size:inherit;line-height:inherit}.t-input[_ngcontent-%COMP%]::-webkit-caps-lock-indicator, .t-input[_ngcontent-%COMP%]::-webkit-contacts-auto-fill-button, .t-input[_ngcontent-%COMP%]::-webkit-credit-card-auto-fill-button, .t-input[_ngcontent-%COMP%]::-webkit-credentials-auto-fill-button, .t-input[_ngcontent-%COMP%]::-webkit-strong-password-auto-fill-button{content:none!important;position:absolute;left:-62.4375rem;top:-62.4375rem;z-index:-999;display:none!important;background:transparent!important;pointer-events:none!important}.t-input[_ngcontent-%COMP%]::placeholder{color:var(--tui-text-tertiary);opacity:0}._focused[_nghost-%COMP%]:not(._readonly)   .t-input[_ngcontent-%COMP%]::placeholder, tui-primitive-textfield._focused:not(._readonly)[_nghost-%COMP%]   .t-input[_ngcontent-%COMP%]::placeholder, tui-primitive-textfield._focused:not(._readonly)   [_nghost-%COMP%]   .t-input[_ngcontent-%COMP%]::placeholder, tui-textarea._focused:not(._readonly)[_nghost-%COMP%]   .t-input[_ngcontent-%COMP%]::placeholder, tui-textarea._focused:not(._readonly)   [_nghost-%COMP%]   .t-input[_ngcontent-%COMP%]::placeholder, tui-text-area._focused:not(._readonly)[_nghost-%COMP%]   .t-input[_ngcontent-%COMP%]::placeholder, tui-text-area._focused:not(._readonly)   [_nghost-%COMP%]   .t-input[_ngcontent-%COMP%]::placeholder{opacity:1}[data-size=s][_nghost-%COMP%]   .t-input[_ngcontent-%COMP%], .t-input   tui-primitive-textfield[data-size=\"s\"][_nghost-%COMP%]:not(tui-primitive-textfield), tui-primitive-textfield[data-size=\"s\"]   [_nghost-%COMP%]:not(tui-primitive-textfield), .t-input   tui-textarea[data-size=\"s\"][_nghost-%COMP%]:not(tui-textarea), tui-textarea[data-size=\"s\"]   [_nghost-%COMP%]:not(tui-textarea), .t-input   tui-text-area[data-size=\"s\"][_nghost-%COMP%]:not(tui-text-area), tui-text-area[data-size=\"s\"]   [_nghost-%COMP%]:not(tui-text-area){padding:0 var(--tui-padding-s)}[data-size=m][_nghost-%COMP%]   .t-input[_ngcontent-%COMP%], .t-input   tui-primitive-textfield[data-size=\"m\"][_nghost-%COMP%]:not(tui-primitive-textfield), tui-primitive-textfield[data-size=\"m\"]   [_nghost-%COMP%]:not(tui-primitive-textfield), .t-input   tui-textarea[data-size=\"m\"][_nghost-%COMP%]:not(tui-textarea), tui-textarea[data-size=\"m\"]   [_nghost-%COMP%]:not(tui-textarea), .t-input   tui-text-area[data-size=\"m\"][_nghost-%COMP%]:not(tui-text-area), tui-text-area[data-size=\"m\"]   [_nghost-%COMP%]:not(tui-text-area){padding:0 var(--tui-padding-m)}[data-size=l][_nghost-%COMP%]   .t-input[_ngcontent-%COMP%], .t-input   tui-primitive-textfield[data-size=\"l\"][_nghost-%COMP%]:not(tui-primitive-textfield), tui-primitive-textfield[data-size=\"l\"]   [_nghost-%COMP%]:not(tui-primitive-textfield), .t-input   tui-textarea[data-size=\"l\"][_nghost-%COMP%]:not(tui-textarea), tui-textarea[data-size=\"l\"]   [_nghost-%COMP%]:not(tui-textarea), .t-input   tui-text-area[data-size=\"l\"][_nghost-%COMP%]:not(tui-text-area), tui-text-area[data-size=\"l\"]   [_nghost-%COMP%]:not(tui-text-area){padding:0 var(--tui-padding-l)}._disabled[_nghost-%COMP%]   .t-input[_ngcontent-%COMP%], .t-input   tui-primitive-textfield._disabled[_nghost-%COMP%], tui-primitive-textfield._disabled   [_nghost-%COMP%], .t-input   tui-textarea._disabled[_nghost-%COMP%], tui-textarea._disabled   [_nghost-%COMP%], .t-input   tui-text-area._disabled[_nghost-%COMP%], tui-text-area._disabled   [_nghost-%COMP%]{pointer-events:none}[data-size=l][_nghost-%COMP%]:not(._label-outside)   .t-input[_ngcontent-%COMP%], .t-input   tui-primitive-textfield[data-size=\"l\"]:not(._label-outside)[_nghost-%COMP%]:not(tui-primitive-textfield), tui-primitive-textfield[data-size=\"l\"]:not(._label-outside)   [_nghost-%COMP%]:not(tui-primitive-textfield){padding-top:1.25rem}[data-size=m][_nghost-%COMP%]:not(._label-outside)   .t-input[_ngcontent-%COMP%], .t-input   tui-primitive-textfield[data-size=\"m\"]:not(._label-outside)[_nghost-%COMP%]:not(tui-primitive-textfield), tui-primitive-textfield[data-size=\"m\"]:not(._label-outside)   [_nghost-%COMP%]:not(tui-primitive-textfield){padding-top:1rem}[data-size=l][_nghost-%COMP%]:not(._label-outside)   .t-input[_ngcontent-%COMP%]{padding-top:1.25rem}[data-size=l][_nghost-%COMP%]:not(._label-outside)   .t-input[_ngcontent-%COMP%]:-webkit-autofill + .t-content[_ngcontent-%COMP%]   .t-placeholder[_ngcontent-%COMP%]{font-size:.8156rem;transform:translateY(-.625rem)}[data-size=m][_nghost-%COMP%]:not(._label-outside)   .t-input[_ngcontent-%COMP%]:-webkit-autofill + .t-content[_ngcontent-%COMP%]   .t-placeholder[_ngcontent-%COMP%]{font-size:.69rem;transform:translateY(-.5rem)}._hidden[_nghost-%COMP%]   input.t-input[_ngcontent-%COMP%], .t-input   tui-primitive-textfield._hidden[_nghost-%COMP%], tui-primitive-textfield._hidden   [_nghost-%COMP%]{opacity:0;text-indent:-10em}.t-content[_ngcontent-%COMP%]{display:flex;block-size:100%;inline-size:100%;box-sizing:border-box;align-items:center;overflow:hidden}[data-size=s][_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{padding:0 var(--tui-padding-s)}[data-size=m][_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{padding:0 var(--tui-padding-m)}[data-size=l][_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{padding:0 var(--tui-padding-l)}.t-wrapper[_ngcontent-%COMP%]{flex:1;min-inline-size:0;padding-inline-end:.25rem}.t-placeholder[_ngcontent-%COMP%]{transition-property:transform,font-size,color,letter-spacing;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;inline-size:100%;-webkit-user-select:none;user-select:none;font:var(--tui-font-text-s);color:var(--tui-text-secondary);pointer-events:none;will-change:transform;transform:translateY(0)}@supports (-webkit-hyphens: none){.t-placeholder[_ngcontent-%COMP%]{will-change:unset;transition-property:transform,color,letter-spacing}}.t-placeholder_raised[_ngcontent-%COMP%]{transform:translateY(-.625rem)}[data-size=m][_nghost-%COMP%]   .t-placeholder_raised[_ngcontent-%COMP%]{font:var(--tui-font-text-xs);line-height:1.25rem;transform:translateY(-.5rem);letter-spacing:.025rem}._invalid[_nghost-%COMP%]:not(._focused)   .t-placeholder_raised[_ngcontent-%COMP%], ._invalid[_nghost-%COMP%]:not(._focused):hover   .t-placeholder_raised[_ngcontent-%COMP%]{color:var(--tui-text-negative)}._focused[_nghost-%COMP%]   .t-placeholder[_ngcontent-%COMP%], [data-size=m]._focused._label-outside[_nghost-%COMP%]   .t-placeholder[_ngcontent-%COMP%], [data-size=l]._focused._label-outside[_nghost-%COMP%]   .t-placeholder[_ngcontent-%COMP%]{color:var(--tui-text-tertiary)}[data-size=l][_nghost-%COMP%]   .t-placeholder[_ngcontent-%COMP%]{font:var(--tui-font-text-m);line-height:1.25rem}[data-size=l][_nghost-%COMP%]   .t-placeholder_raised[_ngcontent-%COMP%]{font-size:.8156rem}[data-size=m]._focused[_nghost-%COMP%]:not(._label-outside)   .t-placeholder[_ngcontent-%COMP%], [data-size=l]._focused[_nghost-%COMP%]:not(._label-outside)   .t-placeholder[_ngcontent-%COMP%]{color:var(--tui-text-primary)}.t-cleaner[_ngcontent-%COMP%]{position:relative;display:flex;inline-size:1.5rem;block-size:1.5rem;align-items:center;justify-content:center;box-sizing:border-box;cursor:pointer;pointer-events:none;pointer-events:auto;border-width:.25rem}._readonly[_nghost-%COMP%]   .t-cleaner[_ngcontent-%COMP%], ._disabled[_nghost-%COMP%]   .t-cleaner[_ngcontent-%COMP%]{pointer-events:none}.t-icon[_ngcontent-%COMP%]{position:relative;display:flex;inline-size:1.5rem;block-size:1.5rem;align-items:center;justify-content:center;box-sizing:border-box;cursor:pointer;pointer-events:none}[data-size=s][_nghost-%COMP%]   .t-icon_left[_ngcontent-%COMP%]{margin:0 .125rem 0 -.375rem}[data-size=m][_nghost-%COMP%]   .t-icon_left[_ngcontent-%COMP%]{margin-inline-start:-.125rem;margin-inline-end:.375rem}[data-size=l][_nghost-%COMP%]   .t-icon_left[_ngcontent-%COMP%]{margin-inline-end:.75rem}.t-icons[_ngcontent-%COMP%]{display:flex;align-items:center}[data-size=m][_nghost-%COMP%]   .t-icons[_ngcontent-%COMP%]{margin-inline-end:-.125rem}[data-size=s][_nghost-%COMP%]   .t-icons[_ngcontent-%COMP%]{margin-inline-end:-.375rem}[_nghost-%COMP%]:not([data-size=s])   .t-icons[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:not(:first-child){margin-inline-start:.25rem}[_nghost-%COMP%]{cursor:text}._expandable[_nghost-%COMP%]{block-size:auto;max-block-size:none}._disabled[_nghost-%COMP%], [_nghost-%COMP%]   *:disabled[_nghost-%COMP%], *:disabled   [_nghost-%COMP%]{pointer-events:none}._readonly[_nghost-%COMP%]{cursor:default}[data-size=m][_nghost-%COMP%]{line-height:1rem}.t-hosted[_ngcontent-%COMP%]{display:block;border-radius:inherit}.t-scrollbar[_ngcontent-%COMP%]{scroll-behavior:var(--tui-scroll-behavior);margin-inline-start:-.25rem;min-inline-size:100%}[_nghost-%COMP%]:not(._label-outside)   .t-scrollbar[_ngcontent-%COMP%], ._label-outside._icon-start[_nghost-%COMP%]   .t-scrollbar[_ngcontent-%COMP%]{margin:0}[data-size=s]._icon-start[_nghost-%COMP%]   .t-scrollbar[_ngcontent-%COMP%]{margin-inline-start:.25rem}[data-size=m][_nghost-%COMP%]:not(._label-outside)   .t-scrollbar[_ngcontent-%COMP%]{border-block-start:1rem solid transparent}[data-size=l][_nghost-%COMP%]:not(._label-outside)   .t-scrollbar[_ngcontent-%COMP%]{border-block-start:1.25rem solid transparent}.t-tags[_ngcontent-%COMP%]{display:flex;padding-inline-start:.25rem}.t-tags_expandable[_ngcontent-%COMP%]{overflow:hidden}.t-tags_empty[_ngcontent-%COMP%]{block-size:0}._expandable[_nghost-%COMP%]   .t-tags[_ngcontent-%COMP%]{flex-wrap:wrap;white-space:normal;overflow:hidden}._readonly[_nghost-%COMP%]   .t-tags[_ngcontent-%COMP%]{pointer-events:none}[data-size=m][_nghost-%COMP%]:not(._label-outside)   .t-tags[_ngcontent-%COMP%], [data-size=l][_nghost-%COMP%]:not(._label-outside)   .t-tags[_ngcontent-%COMP%]{padding:0}.t-tags[_ngcontent-%COMP%]   tui-tag[_ngcontent-%COMP%]:last-of-type{max-inline-size:80%}.t-content[_ngcontent-%COMP%]{align-items:flex-start}[data-size=s][_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{min-block-size:var(--tui-height-s)}[data-size=m][_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{min-block-size:var(--tui-height-m)}[data-size=l][_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{min-block-size:var(--tui-height-l)}[data-size=s][_nghost-%COMP%]   .t-icon-wrapper[_ngcontent-%COMP%]{block-size:var(--tui-height-s)}[data-size=m][_nghost-%COMP%]   .t-icon-wrapper[_ngcontent-%COMP%]{block-size:var(--tui-height-m)}[data-size=l][_nghost-%COMP%]   .t-icon-wrapper[_ngcontent-%COMP%]{block-size:var(--tui-height-l)}.t-absolute-wrapper[_ngcontent-%COMP%]{position:absolute;top:0;left:0;inline-size:100%;block-size:100%;display:flex;flex-direction:column;justify-content:center}[data-size=m][_nghost-%COMP%]   .t-absolute-wrapper[_ngcontent-%COMP%]{block-size:var(--tui-height-m)}[data-size=l][_nghost-%COMP%]   .t-absolute-wrapper[_ngcontent-%COMP%]{block-size:var(--tui-height-l)}.t-wrapper[_ngcontent-%COMP%]{position:relative;display:flex;align-items:center;padding:0;box-sizing:border-box}[data-size=s][_nghost-%COMP%]   .t-wrapper[_ngcontent-%COMP%]{min-block-size:var(--tui-height-s);padding:calc((var(--tui-height-s) - 1.5rem) / 2) 0}[data-size=m][_nghost-%COMP%]   .t-wrapper[_ngcontent-%COMP%]{min-block-size:var(--tui-height-m);padding:calc((var(--tui-height-m) - var(--tui-height-xs) - .25rem) / 2) 0}[data-size=l][_nghost-%COMP%]   .t-wrapper[_ngcontent-%COMP%]{padding:calc((var(--tui-height-l) - var(--tui-height-s) - .25rem) / 2) 0}[data-size=m][_nghost-%COMP%]:not(._label-outside)   .t-wrapper[_ngcontent-%COMP%]{padding:calc((var(--tui-height-m) - 2rem) / 2) 0}[data-size=l][_nghost-%COMP%]:not(._label-outside)   .t-wrapper[_ngcontent-%COMP%]{padding:calc((var(--tui-height-l) - 2.5rem) / 2) 0}.t-tag[_ngcontent-%COMP%]{margin:.125rem .5rem .125rem -.25rem;margin-inline-start:-.25rem;margin-inline-end:.5rem;max-inline-size:100%;flex-shrink:0}[data-size=m][_nghost-%COMP%]   .t-tag[_ngcontent-%COMP%]{margin-inline-start:-.125rem;margin-inline-end:.375rem}.t-text[_ngcontent-%COMP%]:after{content:\",\\a0\"}.t-text_disabled[_ngcontent-%COMP%]{color:var(--tui-text-tertiary)}.t-text_error[_ngcontent-%COMP%]{color:var(--tui-text-negative)}.t-text[_ngcontent-%COMP%]:not(.t-text_comma):last-of-type:after{content:\"\"}[_nghost-%COMP%]:not(._expandable)   .t-text[_ngcontent-%COMP%]{white-space:nowrap}.t-input-wrapper[_ngcontent-%COMP%], .t-value-content[_ngcontent-%COMP%]{position:relative;display:flex;flex:1;max-inline-size:100%}[data-size=s][_nghost-%COMP%]   .t-input-wrapper[_ngcontent-%COMP%], [data-size=s][_nghost-%COMP%]   .t-value-content[_ngcontent-%COMP%]{min-block-size:1.5rem}[data-size=m][_nghost-%COMP%]   .t-input-wrapper[_ngcontent-%COMP%], [data-size=m][_nghost-%COMP%]   .t-value-content[_ngcontent-%COMP%]{min-block-size:calc(var(--tui-height-xs) + 2 * .125rem)}[data-size=l][_nghost-%COMP%]   .t-input-wrapper[_ngcontent-%COMP%], [data-size=l][_nghost-%COMP%]   .t-value-content[_ngcontent-%COMP%]{min-block-size:calc(var(--tui-height-s) + 2 * .125rem)}[_nghost-%COMP%]:not(._label-outside)   .t-input-wrapper[_ngcontent-%COMP%], [_nghost-%COMP%]:not(._label-outside)   .t-value-content[_ngcontent-%COMP%]{min-block-size:1rem}.t-input-wrapper_collapsed[_ngcontent-%COMP%]{flex:0;margin-inline-start:-.5rem}.t-value-content[_ngcontent-%COMP%]:empty{display:none}.t-ghost[_ngcontent-%COMP%]{visibility:hidden;white-space:pre;text-overflow:clip;min-inline-size:.125rem}[_nghost-%COMP%]:not(._expandable)   .t-ghost[_ngcontent-%COMP%]{min-inline-size:2rem}.t-native[_ngcontent-%COMP%]{margin:0;border-width:0;border-radius:inherit;background:none;font-size:inherit;line-height:inherit;font-weight:inherit;color:inherit;caret-color:currentColor;outline:none;-webkit-appearance:none;appearance:none;word-break:keep-all;-webkit-text-fill-color:currentColor;position:absolute;top:0;left:0;inline-size:100%;block-size:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;box-sizing:border-box;padding:0;cursor:inherit}.t-native[_ngcontent-%COMP%]:-webkit-autofill, .t-native[_ngcontent-%COMP%]:-webkit-autofill:hover, .t-native[_ngcontent-%COMP%]:-webkit-autofill:focus{-webkit-text-fill-color:var(--tui-text-primary)!important;border-color:var(--tui-service-autofill-background);box-shadow:0 0 0 100rem var(--tui-service-autofill-background) inset!important}.t-native[inputMode=none][_ngcontent-%COMP%]{caret-color:transparent}.t-native_hidden[_ngcontent-%COMP%]{opacity:0;text-indent:-10em}.t-native[_ngcontent-%COMP%]::placeholder{color:var(--tui-text-tertiary);opacity:0}[tuiTheme=\"dark\"][_nghost-%COMP%]   .t-native[_ngcontent-%COMP%]::placeholder, [tuiTheme=\"dark\"]   [_nghost-%COMP%]   .t-native[_ngcontent-%COMP%]::placeholder{color:var(--tui-text-tertiary)}._focused[_nghost-%COMP%]   .t-native[_ngcontent-%COMP%]:not(:read-only)::placeholder{opacity:1}.t-error-icon[_ngcontent-%COMP%]{display:block;color:var(--tui-status-negative);font-size:1rem}._readonly[_nghost-%COMP%]   .t-textfield-icon[_ngcontent-%COMP%]     [tuiAppearance][data-appearance=icon]{pointer-events:none}@media (hover: hover) and (pointer: fine){[_nghost-%COMP%]:not(._readonly):not(._disabled):hover   .t-textfield-icon[_ngcontent-%COMP%]     [tuiAppearance][data-appearance=icon]:after{color:var(--tui-text-secondary)}}"],
        changeDetection: 0
      });
    }
  }
  return TuiInputTagComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiInputTagModule = /*#__PURE__*/(() => {
  class TuiInputTagModule {
    static {
      this.ɵfac = function TuiInputTagModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiInputTagModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TuiInputTagModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [TuiScrollService],
        imports: [CommonModule, FormsModule, TuiScrollbar, TuiTooltipModule, TuiTagModule, TuiWrapperModule, TuiIcon, i1.TuiDropdownComponent]
      });
    }
  }
  return TuiInputTagModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_INPUT_TAG_DEFAULT_OPTIONS, TUI_INPUT_TAG_OPTIONS, TuiInputTagComponent, TuiInputTagModule, tuiInputTagOptionsProvider };
